// @ts-nocheck
import React from "react";
import {
  Drawer,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { FilterDrawerProps } from "../../Types/types";
import NoSubCategoriesMessage from "./NoSubCategoriesMessage";

interface EnhancedFilterDrawerProps extends FilterDrawerProps {
  isSubCategoryDrawer?: boolean;
}

const FilterDrawer: React.FC<EnhancedFilterDrawerProps> = ({
  open,
  onClose,
  categories,
  subCategories,
  selectedCategories,
  selectedSubCategories,
  onCategorySelect,
  onSubCategorySelect,
  isSubCategoryDrawer,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));


  const handleCategorySelect = (categoryId: string) => {
    const newSelectedCategories = selectedCategories.includes(categoryId)
      ? []
      : [categoryId];

    onCategorySelect(newSelectedCategories);

    // Clear subcategories when category changes
    if (newSelectedCategories.length === 0) {
      onSubCategorySelect([]);
    }
  };

  const handleSubCategorySelect = (subCategoryId: string) => {
    const newSelectedSubCategories = selectedSubCategories.includes(
      subCategoryId
    )
      ? []
      : [subCategoryId];

    onSubCategorySelect(newSelectedSubCategories);
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isSmallScreen ? "100%" : 380,
          marginLeft: isLargeScreen || isMediumScreen ? "auto" : 0,
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          overflow: "hidden",
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(88, 110, 223, .8)",
        },
      }}
    >
      <div className="w-full bg-white dark:bg-darkSecondaryBackground p-4">
        <div className="flex justify-between items-center mb-4">
          <p className="text-xs uppercase tracking-wider text-gray-500 dark:text-white">
            {isSubCategoryDrawer ? "Select Subcategory" : "Select Category"}
          </p>
          <button
            onClick={onClose}
            className="rounded-full p-2 hover:bg-black/5 dark:hover:bg-white/10 text-black dark:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-purple/50"
          >
            <CloseIcon />
          </button>
        </div>
        <div
          className="flex flex-col gap-2 overflow-y-auto"
          style={{
            maxHeight: "45vh",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {categories.map((category) => {
            const isSelected = selectedCategories.includes(
              category.id.toString()
            );
            return (
              <button
                key={category.id}
                onClick={() => handleCategorySelect(category.id.toString())}
                className={`w-full px-4 py-3 rounded-lg font-medium text-sm capitalize transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-purple/50 ${
                  isSelected
                    ? "bg-purple text-white shadow-md"
                    : "bg-white text-gray-800 dark:bg-darkBackground/60 dark:text-white dark:border dark:border-purple/30 shadow-sm hover:shadow-md dark:hover:bg-darkBackground/70"
                }`}
              >
                {category.name}
              </button>
            );
          })}
          {isSubCategoryDrawer &&
            selectedCategories.length > 0 &&
            subCategories.length === 0 && <NoSubCategoriesMessage />}
          {subCategories.map((subCategory) => {
            const isSelected = selectedSubCategories.includes(
              subCategory.id.toString()
            );
            return (
              <button
                key={subCategory.id}
                onClick={() =>
                  handleSubCategorySelect(subCategory.id.toString())
                }
                className={`w-full px-4 py-3 rounded-lg font-medium text-sm capitalize transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-purple/50 ${
                  isSelected
                    ? "bg-purple text-white shadow-md"
                    : "bg-white text-gray-800 dark:bg-darkBackground/60 dark:text-white dark:border dark:border-purple/30 shadow-sm hover:shadow-md dark:hover:bg-darkBackground/70"
                }`}
              >
                {subCategory.name}
              </button>
            );
          })}
        </div>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
